import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout, CommentLayout, OtherChargeLayout, UserDefinedLayout } from './Layout';
import { DisableEnableControls } from "../../../../../../common/Utils";
import { ApplyMethod, YesNo } from "../../../../../../enum/Enum";

function OtherChgsTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});


    const handleAdditionalFormLoad = useCallback(() => {
        loadLookupFromStaticData(formRefs, "Inventoryreview", [{ id: 'N', name: 'No' },{ id: 'Y', name: 'Yes' },  { id: 'R', name: 'Reviewed' }]);
         DisableEnableFields();
    }, []);
        useEffect(() => {
           DisableEnableFields();
        }, [props.formFields]);
    const handleFieldChange = useCallback((name, value, e) => {
    }, []);
    const handleSelectionChange = useCallback((name, value, e) => {

    }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (props.formFields[name])
                formRefs.current[name].instance().option('value', props.formFields[name]);
        }
    };
    const DisableEnableFields = () => {
        if (props.formFields) {
            let isPriceControlsEnabled = true;
            if (props.formFields?.ApplyMethod === ApplyMethod.ApplyMethodSpecifyPrice) {
                isPriceControlsEnabled = props.formFields?.ChangePrice !== YesNo.No;
            }
            DisableEnableControls("Freightrateperitem", !isPriceControlsEnabled, formRefs);
            DisableEnableControls("Handlingchargeperitem", !isPriceControlsEnabled, formRefs);
            DisableEnableControls("Taggingchargeperitem", !isPriceControlsEnabled, formRefs);
        }
    };
    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <FormField
                currrentUser={currentUser}
                layoutId='38A48680-1174-4F3D-AB3C-EA5D23D5AB7A'
                layoutName='OMDetailsOtherChrgForm'
                defaultFormSchema={OtherChargeLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleAdditionalFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OtherChgsTab);
